const { BACKEND_URL } = require("../api/axios.config");

const BASE_URL = "http://13.36.210.209:5000";
//http://15.188.82.46:5000

const URLS = {
  CREATE_USER: `${BASE_URL}user/create-user`,
  VERIF_MAIL: `${BASE_URL}/user/activate-account`,
  RESEND_MAIL_ACTIVATION: `${BASE_URL}user/resend-activation-email`,
  RESET_PASSWORD: `${BASE_URL}/auth/forgot-password`,
  LOGIN: `${BASE_URL}/user/login`,
  SUBSCRIBE_NEWSLETTER: `${BASE_URL}user/subscribe-to-newsletter`,
  GET_USER_DETAILS: `${BASE_URL}user/me`,
  UPDATE_PASSWORD: `${BASE_URL}user/`,
  FETCH_NEWS: `${BASE_URL}news`,
  FETCH_RESILIENCE_PROJECT: `${BASE_URL}resilience-project`,
  FETCH_PROJECT_SUBMISSION: `${BASE_URL}project-submission`,
  VOTE_PROJECT_SUBMISSION: `${BASE_URL}project-vote/vote`,
  PUSH_PROJECT_SUBMISSION: `${BASE_URL}project-submission/send-project`,
  EXCEL_DOWNLOAD_URL: `${BACKEND_URL}/uploads/research/`
};
module.exports = URLS;
